import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getNewDomainStatusKey } from '../../utils/keys';
export const useNewDomainStatus = (options) => {
    const { useQueryOptions, variables } = options || {};
    const { client } = useTribeClient();
    const newDomainStatusKey = getNewDomainStatusKey();
    return useQuery(newDomainStatusKey, () => client.network.newDomainStatus(variables), useQueryOptions);
};
//# sourceMappingURL=useNewDomainStatus.js.map